import React from "react";
import { useSelector } from "react-redux";
import styles from "./promises.scss";
import useQueryParams from "../../../hooks/useQueryParams";
import { getQueryUTMString } from '@tw/shared-ui-components/lib/utils/helper';

const Promises = React.forwardRef((props, ref) => {
  const queryParams = useQueryParams();
  const promises = useSelector(
    (state) => state.pdpState && state.pdpState.promises
  );

  if (!promises) return null;
  if (queryParams) {
    if (promises.link.href.includes("?")) {
      promises.link.href = `${promises.link.href}${getQueryUTMString("&")}`
    } else {
      promises.link.href = `${promises.link.href}${getQueryUTMString("?")}`
    }
  }
  return (
    <div className={styles["promises_container_pdp"]} ref={ref}>
      <div className={styles["promises_pdp"]}>
        {promises.list &&
          promises.list.map((promise, index) => (
            <div className={`${styles["promise_pdp"]}`} key={index}>
              <div className={styles["svg_img_pdp"]}>
                <img src={promise.icon} alt="promise 1" />
              </div>
              <div className={styles["title_and_content_pdp"]}>
                <span className={styles["title_pdp"]}>{promise.title}</span>
                <span className={styles["content_pdp"]}>
                  {promise.subTitle}
                </span>
              </div>
            </div>
          ))}
      </div>
      {promises.link && (
        <>
          <div className={styles["read_more_pdp"]}>
            <a className={styles["rm_pdp"]} href={promises.link.href}>
              {promises.link.title}
              <svg
                width="7"
                height="11"
                viewBox="0 0 8 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.37089 11.3229L7.32097 6.42747C7.55968 6.19137 7.55968 5.8086 7.32094 5.57253L2.37089 0.67706C2.13217 0.44098 1.74514 0.44098 1.5064 0.67706L0.929051 1.24804C0.690711 1.48375 0.690263 1.86575 0.928031 2.102L4.85105 5.99999L0.928031 9.898C0.690263 10.1343 0.690711 10.5163 0.929051 10.752L1.5064 11.3229C1.74511 11.559 2.13215 11.559 2.37089 11.3229Z"
                  fill="#2C2C2C"
                />
              </svg>
            </a>
          </div>
          <div className={styles["read_more_arrow_pdp"]}>
            <a
              rel="noreferrer"
              className={styles["rm_a"]}
              target={promises.link.tabConfig === "new" ? "_blank" : ""}
              href={promises.link.href}
            >
              了解詳情
            </a>
          </div>
        </>
      )}
    </div>
  );
});

export default Promises;
